import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import InterviewCard from './InterviewCard';
import { getFeaturedInterviews, getPublishedInterviews } from '../services/interviewService';
import './InterviewHomeSection.css';

const InterviewHomeSection = () => {
  const [interviews, setInterviews] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    let mounted = true;
    Promise.all([getFeaturedInterviews(), getPublishedInterviews()]).then(
      ([featured, all]) => {
        if (!mounted) return;
        setInterviews(featured.filter((item) => item.hasArticle).slice(0, 4));
        setTotal(all.length);
      }
    );
    return () => {
      mounted = false;
    };
  }, []);

  if (interviews.length === 0) {
    return null;
  }

  return (
    <section className="home-interview-section" aria-labelledby="home-interview-heading">
      <div className="home-interview-inner">
        <div className="home-interview-head">
          <h2 className="home-interview-title" id="home-interview-heading">Interview</h2>
          <p className="home-interview-ja">FLARETECHで働く人の、飾らない本音</p>
        </div>

        <div className="home-interview-strip">
          {interviews.map((interview) => (
            <InterviewCard key={interview.slug} interview={interview} />
          ))}
        </div>

        <div className="home-interview-center">
          <Link to="/interview" className="home-interview-all">
            View All Interviews　{total}名 →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default InterviewHomeSection;
